import { DefaultCountryStrategy } from '~/layouts/components/l10n/countries/DefaultCountryStrategy'
import { Routes } from '~/router/routes'

export class CZECountryStrategy extends DefaultCountryStrategy {
  public readonly statOfficeReportsRoute: Routes | null = Routes.STATOFFICE_REPORT_CZ_INDEX
}
